import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

import TableChoiseDevice from "./TableChoiseDevice";
import axiApi from "ApiCaller";
import {publishEvent} from "core/eventsConnector";
import {PagerModel} from "components/paginator/PaginationModel";
import LoaderSpinner from "context/LoaderSpinner";

const ModalChoiseDevices = ({showModalDevices, setShowModalDevices, chosenDevices = []}) => {
    const {t} = useTranslation("forms");
    const devices = useRef([]);
    const [devicesSel, setDevicesSel] = useState([]);
    const [search, setSearch] = useState("");
    const [items, setItems] = useState([]);
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setItems([]);
        setDevicesSel([]);
        pagerModelRef.current.active = false;
        pagerModelRef.current.handleCallApi = () => postDataFecth();
        getDataFecth();
    }, []);

    const getDataFecth = () => {
        setIsLoading(true);
        axiApi
            .get("/api/devices/search/")
            .then((resp) => {
                const itemsResp = (resp && resp.data && resp.data.items) || [];
                pagerModelRef.current.active = Boolean(itemsResp.length);
                devices.current = itemsResp;
                setItems(itemsResp);
            })
            .finally(() => setIsLoading(false));
    };

    const postDataFecth = () => {
        setIsLoading(true);
        axiApi
            .post(
                "/api/devices/search/",
                {searcher: search},
                {params: pagerModelRef.current.paging.getParams()}
            )
            .then((resp) => {
                const itemsResp = (resp && resp.data && resp.data.items) || [];
                pagerModelRef.current.active = Boolean(itemsResp.length);
                devices.current = itemsResp;
                setItems(itemsResp);
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (chosenDevices.length) {
            setDevicesSel(chosenDevices.map((device) => device.id));
        }
    }, [chosenDevices]);

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        postDataFecth();
    };

    const handleClose = () => {
        setShowModalDevices(false);
    };

    const handleAccept = () => {
        setShowModalDevices(false);
        const selectedDevices = devices.current.filter((device) => devicesSel.includes(device.id));
        publishEvent("devices:modal:select", selectedDevices);
    };

    return (
        <Modal size="lg" show={showModalDevices} onHide={handleClose} animation={true} dialogClassName="modal-dialog-scrollable">
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="object-group" />
                </div>
                <div className="preview-title">
                    <Modal.Title className="d-inline">{t("labels.devices")}</Modal.Title>
                    <form className="d-inline-flex ms-2" role="search" onSubmit={handleSearch}>
                        <input
                            className="form-control border-end-0 rounded-0"
                            type="search"
                            value={search}
                            placeholder="UUID"
                            aria-label="Search"
                            onChange={(e) => setSearch(e.target.value)}
                            name="search"
                        />
                        <button
                            className="btn btn-secondary border-start-0 rounded-0"
                            type="submit"
                            id="button-search">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                        </button>
                    </form>
                </div>
            </Modal.Header>

            <Modal.Body>
                <LoaderSpinner isLoading={isLoading}>
                    <TableChoiseDevice devices={items} devicesSel={devicesSel} setDevicesSel={setDevicesSel} />
                </LoaderSpinner>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Descartar
                </Button>
                <Button variant="primary" onClick={handleAccept}>
                    Seleccionar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalChoiseDevices;
